export interface FileState {
    error: any;
}

export const initialState: FileState = {
    error: null,
};
